import { CircularProgress } from '@mui/material'
import styled from 'styled-components'
import { colors, sizes, fonts } from '../../assets/styles/styleguide'
import { MetamaskFox } from '../logos/Metamask'

const StyledBox = styled.button<{ $loading: boolean }>`
    display: flex;
    align-items: center;
    height: 32px;
    gap: 8px;
    padding: 0px 12px 0px 10px;

    border: 1px solid
        ${(props) => (props.$loading ? colors.secondary : colors.accentGold)};
    box-sizing: border-box;
    border-radius: 12px;
    background: ${colors.background};

    font-family: ${fonts.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: ${sizes.small};
    color: ${(props) =>
        props.$loading ? colors.secondary : colors.accentGold};
    text-align: center;
    line-height: 150%;

    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */

    .logo {
        fill: ${(props) =>
            props.$loading ? colors.background : colors.accentGold};
    }

    :hover {
        background: ${(props) =>
            props.$loading ? colors.background : colors.accentGold};
        color: ${(props) =>
            props.$loading ? colors.secondary : colors.background};
        border-color: ${(props) =>
            props.$loading ? colors.secondary : colors.background};

        .logo {
            fill: ${colors.background};
        }
    }
`

type ComponentProps = {
    onClick: () => void
    loading: boolean
}

const Component = ({ onClick, loading }: ComponentProps) => {
    return (
        <StyledBox $loading={loading} disabled={loading} onClick={onClick}>
            {loading ? (
                <>
                    <CircularProgress size={18} />
                    Connecting
                </>
            ) : (
                <>
                    <MetamaskFox size={18} className={'logo'} />
                    Connect
                </>
            )}
        </StyledBox>
    )
}

export default Component
